// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import { ReviewItem } from '../../components/Reviews/ReviewBox';
import { Dayjs } from 'dayjs';
import { baseQueryWithReauth } from './baseQuery';

// Define a service using a base URL and expected endpoints
export const reviewService = createApi({
  reducerPath: 'reviewService',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['REVIEW_LIST'],

  endpoints: ({ query, mutation }) => ({
    getReviewsList: query<
      { content: ReviewItem[]; totalElements: number; totalPages: number },
      {
        activeProfile: string;
        page: number;
        startDate?: string;
        endDate?: string;
      }
    >({
      query: ({ activeProfile, page, startDate, endDate }) => {
        return {
          url: `/feedback-service/v1/operator-feedback-reports`,
          params: { page, limit: 10, fromDate: startDate, toDate: endDate },
          headers: {
            activeProfile,
          },
        };
      },
      transformResponse: (response: {
        payload: {
          content: ReviewItem[];
          totalElements: number;
          totalPages: number;
        };
      }) => {
        return response.payload;
      },
    }),

    keepReview: mutation({
      query: ({ reviewId, comments }) => ({
        url: `/feedback-service/v1/operator-feedback-reports/${reviewId}/keep`,
        method: 'POST',
        body: {
          comments,
        },
      }),
    }),

    deleteReview: mutation({
      query: ({ reviewId, comments }) => ({
        url: `/feedback-service/v1/operator-feedback-reports/${reviewId}`,
        method: 'DELETE',
        body: {
          comments,
        },
      }),
    }),
    getReceivedFeedbacks: query<any, string>({
      query: (sellerProfileId) => ({
        url: `/feedback-service/v1/operator-feedback-reports/received-feedbacks/${sellerProfileId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetReviewsListQuery,
  useKeepReviewMutation,
  useDeleteReviewMutation,
  useGetReceivedFeedbacksQuery,
} = reviewService;
